<template>
  <v-card>
    <v-card-text>
      <form>
        <v-textarea v-model="cuerpo" :error-messages="cuerpoErrors" label="Respuesta"
                    required @input="$v.cuerpo.$touch()"></v-textarea>
        <AttachFile ref="fileInput" @upload="uploadFiles"></AttachFile>
        <v-btn @click="openFileDirectory" :disabled="saving">Agregar Adjuntos</v-btn>
        <v-btn @click="uploadAllFiles" color="primary" :disabled="saving">Crear</v-btn>
      </form>
    </v-card-text>
  </v-card>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import AttachFile from '../../../common/ui/AttachFile'
import { s3UploadMixin } from '../../../mixins/s3UploadMixin'

export default {
  props: {
    consultaId: Number
  },

  components: {
    AttachFile
  },

  mixins: [validationMixin, s3UploadMixin],

  validations: {
    cuerpo: { required }
  },

  data: () => ({
    cuerpo: '',
    files: [],
    s3uploads: [],
    assets: []
  }),

  computed: {
    cuerpoErrors () {
      const errors = []
      if (!this.$v.cuerpo.$dirty) return errors
      !this.$v.cuerpo.required && errors.push('El cuerpo es requerido.')
      return errors
    }
  },

  methods: {
    submit () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.saving = true
        const payload = {
          consulta: this.consultaId,
          texto: this.cuerpo
        }
        this.axios
          .post('/mensaje', payload)
          .then((response) => {
            this.$refs.fileInput.cleanContent()
            let newMessage = response.data
            if (this.assets.length > 0) {
              this.axios
                .put('/mensaje/upload-s3/' + newMessage.id, { assets: this.assets })
                .then((responseS3) => {
                  newMessage.assets = responseS3.data.uploadedAssets
                  this.update(newMessage)
                  this.clear()
                  this.saving = false
                })
                .catch(error => { this.$store.commit('setErrorMsg', error) })
            } else {
              this.update(newMessage)
              this.clear()
              this.saving = false
            }
          })
          .catch(error => {
            this.$store.commit('setErrorMsg', error)
            this.saving = false
          })
      }
    },
    uploadFiles (newFiles) {
      this.files = newFiles
    },
    update (newMessage) {
      this.$emit('update', newMessage)
    },
    clear () {
      this.cuerpo = ' '
      this.files = []
      this.s3uploads = []
      this.assets = []
    },
    openFileDirectory () {
      this.$refs.fileInput.onPickFile()
    }
  }
}
</script>
